import countryList from "react-select-country-list";

// English + native labels ("Germany", "Deutschland", "Österreich", ...)
const countries = countryList().native();
// English labels only — they are the i18n keys for the translated names
const englishCountries = countryList();

const PREFERRED_ORDER = ["DE", "AT", "CH"];

/**
 * Select options for country pickers: DE, AT, CH first, then by ISO code.
 * Labels go through `t`, so the German UI shows German country names.
 */
export function getCountryOptions(t) {
	return countryList().getData()
		.map(c => ({ text: t(c.label), value: c.value }))
		.sort((a, b) => {
			const indexA = PREFERRED_ORDER.indexOf(a.value);
			const indexB = PREFERRED_ORDER.indexOf(b.value);
			if (indexA > -1 && indexB > -1) return indexA - indexB;
			if (indexA > -1) return -1;
			if (indexB > -1) return 1;
			return a.value.localeCompare(b.value);
		});
}

/**
 * Display name for a stored country value: ISO codes become the translated
 * country name, anything else (legacy free text) is shown as is.
 */
export function getCountryName(value, t) {
	if (!value) return "";
	const label = englishCountries.getLabel(String(value).trim());
	return label ? t(label) : value;
}

/**
 * Country fields in user profiles and company billing data are free text, so
 * they hold "DE", "de", "Germany" or "Deutschland". Country selects only know
 * ISO codes — map the stored value to one, or "" if it can't be resolved.
 * Pass `t` to also resolve translated names ("Niederlande").
 */
export function normalizeCountryCode(value, t) {
	if (!value) return "";
	const trimmed = String(value).trim();
	if (!trimmed) return "";
	if (countries.getLabel(trimmed)) return trimmed.toUpperCase();
	const byLabel = countries.getValue(trimmed);
	if (byLabel) return byLabel;
	if (t) {
		const lower = trimmed.toLowerCase();
		const match = countryList().getData().find(c => String(t(c.label)).toLowerCase() === lower);
		if (match) return match.value;
	}
	return "";
}
